"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./DragNDropWrapper.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DragNDropWrapper = function DragNDropWrapper(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      relative = _ref.relative,
      absolute = _ref.absolute,
      onFileDrop = _ref.onFileDrop,
      error = _ref.error,
      errorMessage = _ref.errorMessage,
      accept = _ref.accept;
  var refDnd = (0, _react.useRef)(null);
  var refInput = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      dragging = _useState2[0],
      setDragging = _useState2[1];

  var dragCounter = 0;

  var openFileDialog = function openFileDialog(e) {
    e.stopPropagation();
    if (disabled) return;
    refInput.current.click();
  };

  var handleDrag = function handleDrag(e) {
    e.preventDefault();
    e.stopPropagation();
  };

  var handleDragIn = function handleDragIn(e) {
    e.preventDefault();
    e.stopPropagation();
    if (disabled) return;
    dragCounter++;

    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      setDragging(true);
    }
  };

  var handleDragOut = function handleDragOut(e) {
    e.preventDefault();
    e.stopPropagation();
    if (disabled) return;
    dragCounter--;
    if (dragCounter > 0) return;
    setDragging(false);
  };

  var handleDrop = function handleDrop(e) {
    e.preventDefault();
    e.stopPropagation();
    if (disabled) return;
    setDragging(false);

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      onFileDrop(e.dataTransfer.files);
      e.dataTransfer.clearData();
      dragCounter = 0;
    }
  };

  (0, _react.useEffect)(function () {
    var div = refDnd.current;
    div.addEventListener('dragenter', handleDragIn);
    div.addEventListener('dragleave', handleDragOut);
    div.addEventListener('dragover', handleDrag);
    div.addEventListener('drop', handleDrop);
    dragCounter = 0;
    return function () {
      var div = refDnd.current;
      div.removeEventListener('dragenter', handleDragIn);
      div.removeEventListener('dragleave', handleDragOut);
      div.removeEventListener('dragover', handleDrag);
      div.removeEventListener('drop', handleDrop);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: refDnd,
    className: "gcl-dnd ".concat(relative ? 'relative' : '', " ").concat(absolute ? 'absolute' : '')
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "file",
    ref: refInput,
    onChange: function onChange(e) {
      return onFileDrop(e.target.files);
    },
    accept: accept
  }), /*#__PURE__*/_react["default"].cloneElement(children, {
    error: error,
    errorMessage: errorMessage,
    dragging: dragging,
    openFileDialog: openFileDialog,
    disabled: disabled
  }));
};

DragNDropWrapper.propTypes = {
  onFileDrop: _propTypes["default"].func.isRequired,
  absolute: _propTypes["default"].bool,
  relative: _propTypes["default"].bool,
  error: _propTypes["default"].bool,
  children: _propTypes["default"].object,
  errorMessage: _propTypes["default"].string,
  accept: _propTypes["default"].string,
  disabled: _propTypes["default"].bool
};
var _default = DragNDropWrapper;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/DragNDropWrapper/DragNDropWrapper.js
// module id = 1899
// module chunks = 0